import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.Order.IRequest;
type Response = Api.Core.ProductDocument.Order.IResponse;
type Headers = Api.Core.ProductDocument.Order.IHeaders;
const url = '/api/ProductManagement/ProductDocument/DocumentOrder';
export default async function productDocumentOrderApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
